<div class="content" #descriptionContainer [innerHTML]="descriptionContent">
</div>